import {
  ADD_SURVEY,
  ADD_SURVEY_FAILED,
  ADD_SURVEY_SUCCESS,
  GET_SURVEY_FEATURE,
  GET_SURVEY_FEATURE_SUCCESS,
  GET_SURVEY_FEATURE_FAILED,
  RESET_SURVEY_FEATURE,
  GET_SURVEY_LIST,
  UPDATE_SURVEY,
  UPDATE_SURVEY_SUCCESS,
  UPDATE_SURVEY_FAILED,
  GET_SURVEY_LIST_SUCCESS,
  GET_SURVEY_LIST_FAILED,
  UPDATE_SURVEY_RESPONSE,
  UPDATE_SURVEY_RESPONSE_SUCCESS,
  UPDATE_SURVEY_RESPONSE_FAILED,
  OPEN_DELETE_SURVEY_MODAL,
  HIDE_DELETE_SURVEY_MODAL,
  DELETE_SURVEY,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAILED,
  UPDATE_SURVEY_ORDER,
  UPDATE_SURVEY_ORDER_SUCCESS,
  UPDATE_SURVEY_ORDER_FAILED,
  UPDATE_SURVEY_STATUS,
  UPDATE_SURVEY_STATUS_SUCCESS,
  UPDATE_SURVEY_STATUS_FAILED,
  RESET_SURVEY_LIST,
  GET_SURVEY_REPLY,
  GET_SURVEY_REPLY_SUCCESS,
  GET_SURVEY_REPLY_FAILED,
  RESET_SURVEY_REPLY,
  GET_SURVEY_FEATURE_RECIPIENTS,
  GET_SURVEY_FEATURE_RECIPIENTS_SUCCESS,
  GET_SURVEY_FEATURE_RECIPIENTS_FAILED,
  RESET_SURVEY_FEATURE_RECIPIENTS,
} from "./actionTypes"

export const addSurvey = params => ({
  type: ADD_SURVEY,
  payload: params,
})

export const addSurveySuccess = response => ({
  type: ADD_SURVEY_SUCCESS,
  payload: response,
})

export const addSurveyFailed = error => ({
  type: ADD_SURVEY_FAILED,
  payload: error,
})

export const getSurveyFeature = params => ({
  type: GET_SURVEY_FEATURE,
  payload: params,
})

export const getSurveyFeatureSuccess = response => ({
  type: GET_SURVEY_FEATURE_SUCCESS,
  payload: response,
})

export const getSurveyFeatureFailed = error => ({
  type: GET_SURVEY_FEATURE_FAILED,
  payload: error,
})

export const resetSurveyFeature = () => ({
  type: RESET_SURVEY_FEATURE,
  payload: {},
})

export const getSurveyList = params => ({
  type: GET_SURVEY_LIST,
  payload: params,
})

export const updateSurvey = params => ({
  type: UPDATE_SURVEY,
  payload: params,
})

export const updateSurveySuccess = response => ({
  type: UPDATE_SURVEY_SUCCESS,
  payload: response,
})

export const updateSurveyFailed = error => ({
  type: UPDATE_SURVEY_FAILED,
  payload: error,
})

export const getSurveyListSuccess = response => ({
  type: GET_SURVEY_LIST_SUCCESS,
  payload: response,
})

export const getSurveyListFailed = error => ({
  type: GET_SURVEY_LIST_FAILED,
  payload: error,
})

export const resetSurveyList = () => ({
  type: RESET_SURVEY_LIST,
  payload: {},
})

export const updateSurveyResponse = params => ({
  type: UPDATE_SURVEY_RESPONSE,
  payload: params,
})

export const updateSurveyResponseSuccess = response => ({
  type: UPDATE_SURVEY_RESPONSE_SUCCESS,
  payload: response,
})

export const updateSurveyResponseFailed = error => ({
  type: UPDATE_SURVEY_RESPONSE_FAILED,
  payload: error,
})

export const openDeleteSurveyModal = () => ({
  type: OPEN_DELETE_SURVEY_MODAL,
  payload: {},
})

export const hideDeleteSurveyModal = () => ({
  type: HIDE_DELETE_SURVEY_MODAL,
  payload: {},
})

export const deleteSurvey = params => ({
  type: DELETE_SURVEY,
  payload: params,
})

export const deleteSurveySuccess = response => ({
  type: DELETE_SURVEY_SUCCESS,
  payload: response,
})

export const deleteSurveyFailed = error => ({
  type: DELETE_SURVEY_FAILED,
  payload: error,
})

export const updateSurveyOrder = params => ({
  type: UPDATE_SURVEY_ORDER,
  payload: params,
})

export const updateSurveyOrderSuccess = response => ({
  type: UPDATE_SURVEY_ORDER_SUCCESS,
  payload: response,
})

export const updateSurveyOrderFailed = error => ({
  type: UPDATE_SURVEY_ORDER_FAILED,
  payload: error,
})

export const updateSurveyStatus = params => ({
  type: UPDATE_SURVEY_STATUS,
  payload: params,
})

export const updateSurveyStatusSuccess = response => ({
  type: UPDATE_SURVEY_STATUS_SUCCESS,
  payload: response,
})

export const updateSurveyStatusFailed = error => ({
  type: UPDATE_SURVEY_STATUS_FAILED,
  payload: error,
})

export const getSurveyReply = params => ({
  type: GET_SURVEY_REPLY,
  payload: params,
})

export const getSurveyReplySuccess = response => ({
  type: GET_SURVEY_REPLY_SUCCESS,
  payload: response,
})

export const getSurveyReplyFailed = error => ({
  type: GET_SURVEY_REPLY_FAILED,
  payload: error,
})

export const resetSurveyReply = () => ({
  type: RESET_SURVEY_REPLY,
  payload: {},
})

export const getSurveyFeatureRecipients = params => ({
  type: GET_SURVEY_FEATURE_RECIPIENTS,
  payload: params,
})

export const getSurveyFeatureRecipientsSuccess = response => ({
  type: GET_SURVEY_FEATURE_RECIPIENTS_SUCCESS,
  payload: response,
})

export const getSurveyFeatureRecipientsFailed = error => ({
  type: GET_SURVEY_FEATURE_RECIPIENTS_FAILED,
  payload: error,
})

export const resetSurveyFeatureRecipients = () => ({
  type: RESET_SURVEY_FEATURE_RECIPIENTS,
  payload: {},
})
